<!--
 * @Description: 展示手机号弹框
 * @Author: fal
 * @FilePath: \web\pc.ui\src\project\components\showPhoneNumber.vue
 * @LastEditTime: 2025-02-08 10:30:06
-->
<template>
  <el-dialog class="phone-call" :visible="dialogVisible" width="360px" top="15%" :show-close="false" append-to-body>
    <div class="modal-content">
      <img src="@/project/assets/front/icon-phone-call.png" alt="" class="phone-call" />
      <p class="del-text">{{ msg || '' }}</p>
      <div class="button-group">
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
        <el-button v-if="msg" class="confirm-btn" type="primary" @click="handleConfirmFn">复制号码</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'showPhoneNumber',
  props: ['phone'],
  data() {
    return {
      msg: '',
      dialogVisible: true,
      handleConfirmFn: this.$throttle(this.handleConfirm),
    };
  },
  watch: {
    phone: {
      handler(val) {
        this.msg = val;
      },
      immediate: true,
    },
  },
  methods: {
    handleConfirm() {
      navigator.clipboard
        .writeText(this.msg)
        .then(() => {
          // 弹出提示
          this.$message.success('联系方式已复制到剪贴板！');
          this.$emit('close');
        })
        .catch((err) => {
          this.$message.error('复制联系方式失败！');
        });
    },

    handleCancel() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.phone-call {
  :deep(.el-dialog) {
    border-radius: 8px;
    background: url('@/project/assets/del-bg.png') no-repeat center;
    background-size: cover;
    height: 203px;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone-call {
    position: absolute;
    top: -72px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 200px;
    height: 140px;
  }

  .del-text {
    margin: 24px 0 26px;
    font-size: 20px;
    font-weight: 800;
    color: #333;
  }

  .button-group {
    display: flex;
  }

  .cancel-btn {
    font-size: 20px;
    width: 112px;
    border-radius: 4px;
  }

  .confirm-btn {
    margin-left: 20px;
    font-size: 20px;
    width: 112px;
    border-radius: 4px;
    background-color: #2468f2;
  }
}
</style>
